module.exports = __webpack_public_path__ + "static/key-beholder-8ab0e734bdaf492554643e9881ae04a0.webp";